export const getRandomNumber = (digit = 3) => {
  const typedArray = new Uint16Array(1);
  const randomValue =
    Math.ceil(crypto.getRandomValues(typedArray)[0] / 100) + "";
  if (randomValue.length < digit) {
    return randomValue.padStart(digit, "0");
  }
  return randomValue;
};
